import React from 'react'

function TenderTextAVACS() {
  return (
    <embed src="\pdfs\EAT2.3.1_AVACS_Multifunction_sail_kr.pdf" width="100%" height="2100px" />
  )
}

export default TenderTextAVACS